/**
 * legal-guarantee.js — opens the EU legal guarantee notice
 * (snippets/legal-guarantee.liquid) in a native modal <dialog>.
 *
 * Clicks are delegated from document because the cart drawer replaces its
 * body (and the link in it) after every cart change. Without JavaScript, or
 * without <dialog> support, the links simply open /pages/zakonsko-jamstvo.
 */
(() => {
  const dialog = document.querySelector('[data-legal-guarantee]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-legal-guarantee-open]')) {
      event.preventDefault();
      // An open drawer marks every other child of <body> inert, this dialog
      // included (drawer-focus.js), which would leave it unclickable.
      dialog.removeAttribute('inert');
      dialog.showModal();
      return;
    }
    // A click on the dialog element itself lands on the backdrop.
    if (event.target === dialog || event.target.closest('[data-legal-guarantee-close]')) {
      dialog.close();
    }
  });

  // Esc closes the dialog natively; keep it from also closing the drawer below.
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') event.stopPropagation();
  });
})();
